module.exports = __webpack_public_path__ + "static/media/finger_delete_red.ec536dfb.svg";